import BoardingProgress from '../BoardingProgress.js';
import { Divider } from '@fluentui/react-components';
import Complete from './Complete.js';



const SetUpComplete = () => {
  const currentProgressStep = 3

  return (
    <>
      <div
        style={{
          display: 'flex',
          width: '100%',
          minheight: '1100px',
          margin: 'auto',
          flexDirection: 'column',
          alignContent: 'center',
          background: '#FAF9F8'
        }}
      >
        <div style={{
          width: '1400px',
          backgroundColor: '#FAF9F8',
          margin: '0 auto',
          height: '1600px',

        }}>
          <BoardingProgress currentProgressStep={currentProgressStep} />

          <div style={{
            marginTop: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'center',
          }}>
            <Divider style={{ width: '1200px', marginTop: '40px' }} />
          </div>
          <div style={{ color: 'black', display: 'flex', marginTop: '50px', width: '100%', justifyContent: 'center', }}>
          </div>
          <Complete />
        </div>
      </div>
    </>
  );
};

export default SetUpComplete;
